import {RecursosController} from "../recursos";

export class EstadioController extends RecursosController {

    /* INSTANCE */
    public static instance: EstadioController;

    /* STATIC */
    public static override async build(): Promise<void> {
        EstadioController.instance = new this();
        RecursosController.instances.push(EstadioController.instance);
    }

    constructor() {
        super();
        this.getResources(document.body).then(async()=>{
            await this.init();
            this.scrollEvent = this.lazyResources.bind(this);
            document.addEventListener("scroll", this.scrollEvent);
        });
    }

    protected async getResources(html: HTMLElement): Promise<void> {
        const resources = Array.from(html.querySelectorAll("[class*='ed-widget-body'], [class*='ed-widget-live'], [class*='ed-blockquote-body'], [class*='ed-blockquote-live']"));
        for (let resource of resources) this.resources.push(resource as HTMLElement);
    }

    protected async load(item: HTMLElement): Promise<void> {
        item.innerHTML = item.getAttribute("data-lazy") as string;
    }

}
